/// <reference types="monaco-editor" />

const bundle = process.env.NODE_ENV === 'development' ? 'dev' : 'min';
const bundlePath = `https://imgcache.qq.com/qcloud/main/scripts/release/common/vendors/monaco-editor/${bundle}/`;

let prepared = null;

/**
 * @returns {Promise<monaco>}
 */
export function prepareMonaco() {
	// 非浏览器环境
	if (typeof window === 'undefined') {
		throw new Error('Monaco Editor is only for browser context');
	}
	if (typeof AMDLoader !== 'object') {
		console.warn(
			'使用 MonacoEditor 必须先引入其 loader 脚本。' +
			`请添加：<script src="${bundlePath}/vs/loader.js">`
		);
		throw new Error('Monaco loader not found');
	}

	if (prepared) return prepared;
	/**
	 * 解决 worker 跨域问题
	 * @see https://github.com/Microsoft/monaco-editor#integrate-cross-domain
	 */
	const workerCode = `
	self.MonacoEnvironment = {
		baseUrl: '${bundlePath}'
	};
	importScripts('${bundlePath}/vs/base/worker/workerMain.js');
	`;
	const worker = URL.createObjectURL(new Blob([workerCode], {
		type: 'text/javascript'
	}));
	return prepared = new Promise((resolve, reject) => {
		window.require.config({
			paths: {
				'vs': `//imgcache.qq.com/qcloud/main/scripts/release/common/vendors/monaco-editor/${bundle}/vs`
			},
			'vs/nls': {
				availableLanguages: {
					'vs/editor/editor.main': 'zh-cn'
				}
			}
		});

		let timer = setTimeout(() => {
			reject(new Error('Load editor script timeout'));
		}, 5 * 1000);

		// 手动指定worker路径为一个blob url
		window.MonacoEnvironment = {
			getWorkerUrl: () => worker
		};

		window.require(['vs/editor/editor.main'], () => {
			clearTimeout(timer);
			if (window.monaco) {
				resolve(window.monaco);
			} else {
				reject(new Error('Init script error! global.monaco not found'));
			}
		});
	});
}



// WEBPACK FOOTER //
// ./lib/editor/MarkdownEditor/loader.js